import './js/texts'
import './js/homeslider'
import './js/socialicons'
import './js/comments'
import './js/sc-categories'
import './js/sc-searchcategoriesfind'
import './js/sc-searchcategoriestext'
import './js/sc-useraccount'
import './js/sc-usercourses'
import './js/sc-listcourses'
import './js/sc-certificate'
import './js/sc-resources'
import './js/login-register'
import './js/userinvited'
import './js/events'
import './js/openregistry'
import './js/header'
import './js/specialtranslations'
import './js/partnersupport'
import './js/accessdenied'
